import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { SCROLL_TARGET } from '../data/content';
interface CTAButtonProps {
  children: React.ReactNode;
  variant?: 'coral' | 'sage' | 'outline';
  size?: 'md' | 'lg';
  className?: string;
}
function scrollToPurchase() {
  const el = document.getElementById(SCROLL_TARGET);
  if (el) {
    el.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
}
export function CTAButton({
  children,
  variant = 'coral',
  size = 'lg',
  className = ''
}: CTAButtonProps) {
  const base = 'inline-flex items-center justify-center gap-2 rounded-full font-semibold tracking-wide transition-all duration-200 focus:outline-none focus-visible:ring-4 focus-visible:ring-coral/30 active:scale-[0.98]';
  const variants: Record<string, string> = {
    coral: 'bg-coral text-white hover:bg-coral-deep shadow-lg shadow-coral/25 hover:shadow-xl hover:shadow-coral/30',
    sage: 'bg-sage-deep text-white hover:bg-[#4e6a4d] shadow-lg shadow-sage-deep/25',
    outline: 'bg-transparent text-sage-deep border-2 border-sage-deep hover:bg-sage-deep hover:text-white'
  };
  const sizes: Record<string, string> = {
    md: 'px-6 py-3 text-sm',
    lg: 'px-8 py-4 text-base sm:text-lg'
  };
  return <button type="button" onClick={scrollToPurchase} className={`${base} ${variants[variant]} ${sizes[size]} ${className}`} data-id="element-42">
      <span data-id="element-43">{children}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-44" />
    </button>;
}